<template>
    <div v-if="product">
        <div class="smake">
            <div class="pa-0 px-10" style="border-bottom: 1px solid rgba(0, 0, 0, 0.25);">
                <div class="page d-flex flex-wrap">
                    <div class="col-12 pt-5 pb-5 d-flex justify-space-between" >
                        <div class="col-12 d-flex row justify-space-between  align-center flex-wrap">
                            <div class="d-flex flex-row left-arrow row justify-start align-center flex-wrap">
                                <div class="d-flex flex-row align-center">
                                    <v-img @click="$router.push('/products')"  class="hover" max-height="30px" max-width="28px" :src="$root.getSrc('/default/drop_icons/left_arrow.svg')" contain></v-img>
                                    <span class="kanit-normal ml-2">Back to<br>products</span>
                                </div>

                                <div class="d-flex flex-column justify-start ml-5">
                                    <span class="fs-24 fw-600">
                                        {{ product.name.substring(0, 40) }}
                                    </span>
                                </div>
                            </div>
                            <v-spacer></v-spacer>
                            <div class="d-flex justify-center align-center flex-column">
                                <v-btn v-ripple="false" :loading="creating" @click="updateProduct" class="white--text drop-button button-primary-active" color="#4353FF">
                                    {{product.id ? 'Update product' : 'Create product'}}
                                </v-btn>
                                <span v-if="creating">{{ product.id ? 'Updating' : 'Creating' }} Product...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pb-0">
            <div class="page d-flex row ">
                <div class="col-md-8 pb-0 d-flex flex-column">
                    <div class="d-flex align-center justify-center flex-column w-100" >
                        <div  :style="width >= 960 ? 'position: fixed; top: 18%;' : ''" class="row" v-if="printImages && printImages.length > 0">
                            <div class="col-md-12 mt-5 d-flex align-center justify-center w-100"  v-if="printImages">
                            <span @click="activeSide = side.place; getBackgroundImage(null,side.image)"
                                  :class="[side.place == activeSide ? 'active-side' : 'inactive-side', index > 0 ? 'ml-4' : 'ml-0']"
                                  v-for="(side,index) in printImages">
                                {{ side.place.charAt(0).toUpperCase() + side.place.slice(1) }}
                            </span>
                            </div>
                        </div>
                        <div  :style="width >= 960 ? 'position: fixed; top: 25%;' : ''" class="w-100">
                            <div id="konva-wrapper" tabindex="0" style="display:flex; position: relative; justify-content: center">
                                <div v-if="configKonva && background && background.src">
                                    <v-stage ref="stage" :config="configKonva"
                                             @mousedown="handleStageMouseDown"
                                             @mouseup="handleTransformEnd"
                                             @touchstart="handleStageMouseDown"
                                    >
                                        <v-layer ref="background">
                                            <v-image key="image" :config="backgroundConfig"/>
                                        </v-layer>
                                        <v-layer :config="clippingConfig">
                                            <v-rect v-if="!previewMode  && !mode" :config="rectConfig"></v-rect>
                                            <v-rect v-if="!previewMode && !mode" :config="rectConfigOutline"></v-rect>
                                        </v-layer>

                                        <v-layer ref="designMockup" :config="clippingConfig" >
                                            <div v-if="design.side == activeSide" v-for="design in selectedlayersReverted">
                                                <v-image v-if="design.type == 'image' && !refreshProject" :key="design.id" :ref="design.id" :config=" mode ? {...design, name: design.id, draggable: false} : {...design, name: design.id}"/>
                                                <v-text v-if="design.type == 'text' && !refreshProject" :key="design.id" :ref="design.id" :config="mode ? {...design, name: design.id, draggable: false} : {...design, name: design.id}"></v-text>
                                            </div>
                                        </v-layer>
                                        <v-layer :config="clippingConfig">
                                            <v-transformer v-if="!refreshProject && !mode" :config="{centeredScaling: true, rotationSnaps: [0, 45, 90, 135, 180, 225, 270, 315],  enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']}" ref="transformer"/>
                                        </v-layer>
                                    </v-stage>
                                    <div class="d-flex align-center justify-center w-100 h-100" style="position: absolute; left: 0px; top: 0px" v-if="saving">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    </div>
                                    <div class="d-flex align-center justify-center w-100" style="height100%; position: absolute; left: 0px; top: 0px; background-color: rgba(0,0,0,0.4)" v-if="fetching_file">
                                        <div class="d-flex">
                                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                            <div class="ml-2">{{$t('Fetching production file...')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 expansion pl-0">
                    <div>
                        <div v-if="product && !productDetails">
                            <v-expansion-panels @clik="titlePanel = 0" eager style="position: relative;" class="right-container" >
                                <v-expansion-panel class="elevation-0">
                                    <v-expansion-panel-header>
                                        <template v-slot:actions>
                                            <v-icon class="icon-reverse">$expand</v-icon>
                                        </template>
                                        <div class="d-flex header-reverse flex-column">
                                            <span class="kanit-bold fs-24 ml-5">Create your design</span>
                                            <span class="kanit-normal fs-16 mt-3 ml-5">Select colours, designs and  text here for your products</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content v-show="titlePanel == 0" class="pl-0" eager>

                                        <div class="row colors-container">
                                            <div class="col-md-6">
                                                <div class="d-flex flex-row align-center">
                                                    <v-img  max-height="32px" max-width="32px" :src="$root.getSrc('/default/palette.svg')" contain></v-img>
                                                    <span class="fs-16 ml-3 kanit-bold">Colors</span>
                                                </div>
                                                <div class="mt-10 d-flex flex-row flex-wrap">
                                                    <div class="hover mb-1 mr-2" @click="specificColor = null; selectedColor = color.color_name;" style="position: relative;" v-for="(color,index) in selectedColors">
                                                        <v-img :class="specificDesignForColor && selectedColor == color.color_name ? 'specific-design-border' : ''" style="border-radius: 100%;" width="32px" height="32px" contain :src="getSrc(color.color_swatch)"></v-img>
                                                        <v-img v-if="selectedColor == color.color_name"  style="position: absolute; right: 0; top: 0;" width="24px" height="24px" contain :src="$root.getSrc('/default/drop_icons/check.svg')"></v-img>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-row mt-3">
                                                    <v-checkbox
                                                        class="no-validation"
                                                        color="#2F80ED"
                                                        v-model="specificDesignForColor"
                                                    ></v-checkbox>
                                                    <span @click="specificDesignForColor=!specificDesignForColor" class="kanit-normal hppver fs-16">Make a specific design for&nbsp;{{selectedColor}}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 d-flex flex-column">
                                                <span @click="editColors = !editColors" class="hover">
                                                    Chosen colours ({{selectedColors ? selectedColors.length : 0}} out of {{colorSwatches.length}})
                                                    <v-icon style="width: 16px; height: 16px" class="icon-reverse">{{ !editColors ? 'mdi-chevron-down' : 'mdi-chevron-up'}}</v-icon>
                                                </span>
                                                <div v-if="editColors " class="d-flex mt-2 flex-row flex-wrap">
                                                    <div @click="changeColor(color.color_name, index)" style="position: relative;" class="hover mb-1 mr-2" v-for="(color,index) in colorSwatches">
                                                        <v-img style="border-radius: 100%;" width="32px" height="32px" contain :src="getSrc(color.color_swatch)"></v-img>
                                                        <v-img v-if="selectedColorsName.indexOf(color.color_name) > -1"  style="position: absolute; right: 0; top: 0;" width="24px" height="24px" contain :src="$root.getSrc('/default/drop_icons/check.svg')"></v-img>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12 row mb-5">
                                                <div :key="item.type" @click="type = item.type" class="col-md-4" v-for="item in options">
                                                    <div class="store-design-option hover pa-4" :class="type == item.type ? 'store-design-option-active' : ''">
                                                        <v-img class="mb-2" max-height="48px" :src="$root.getSrc('/default/'+item.image)" contain></v-img>
                                                        <span class="fs-16 kanit-bold">{{item.text}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="type == 'layer'">
                                            <div class="layers-container" :key="design.id" :class="index > 0 ? 'mt-3' : 'mt-0'" v-for="(design, index) in selectedLayers">
                                                <div v-if="design.type=='image'">
                                                    <div class="d-flex flex-row justify-space-between align-center">
                                                        <div class="d-flex flex-row align-center">
                                                            <div v-if="!mode" class="d-flex flex-column justify-space-around mr-2">
                                                                <v-img v-if="index==0" class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_up.svg')" contain ></v-img>
                                                                <v-img v-else @click="moveUpGraphic(design.id)" class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_up_enabled.svg')" contain ></v-img>
                                                                <v-img v-if="index+1 < layers.length" @click="moveDownGraphic(design.id)" class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_down.svg')" contain ></v-img>
                                                                <v-img v-else class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_down_disabled.svg')" contain ></v-img>
                                                            </div>
                                                            <v-img @click="$set(design,'expanded', !design.expanded)" class="ml-1 hover" max-height="56px" max-width="56px" :src="design.src" contain></v-img>
                                                            <div @click="$set(design,'expanded', !design.expanded)" class="ml-1 d-flex flex-column hover">
                                                                <span class="fs-16 fw-600">Design_col01.png</span>
                                                                <span class="fs-14 fw-400">Graphic layer</span>
                                                            </div>
                                                        </div>

                                                        <div v-if="!mode" class="d-flex justify-end" style="height: 100%;">
                                                            <v-img @click="deleteLayer(design.id)" class="hover" max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/trash.svg')" contain></v-img>
                                                        </div>
                                                    </div>
                                                    <div v-if="design.expanded && !mode" class="mt-3">
                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Size</p>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field type="number" @change="updateLayerValue($event,design,'height')" min="0" step="0.01" class="no-validation" color="blue" :value="getLayerParams(design).height" outlined label="Height">
                                                                    <template v-slot:append>
                                                                        <span style="white-space:nowrap;" class="fs-14 mt-2 fw-400">cm</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field type="number" @change="updateLayerValue($event,design,'width')" min="0" step="0.01" class="no-validation" :value="getLayerParams(design).width"  color="blue" outlined label="Width">
                                                                    <template v-slot:append>
                                                                        <span style="white-space:nowrap;" class="fs-14 mt-2 fw-400">cm</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                        </div>

                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Transform</p>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field type="number" @change="updateLayerValue($event,design,'rotation')" :value="getLayerParams(design).rotation"  min="0" max="360" step="0.01" class="no-validation" color="blue" outlined label="Rotate">
                                                                    <template v-slot:append>
                                                                        <span style="white-space:nowrap;" class="fs-14 fw-400">deg</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                        </div>

                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Position</p>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field  type="number" @change="updateLayerValue($event,design,'left')" min="0" step="0.01" :value="getLayerParams(design).left" class="no-validation" color="blue" outlined label="Left">
                                                                    <template v-slot:append>
                                                                        <span class="fs-14 fw-400">%</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field  type="number" @change="updateLayerValue($event,design,'top')" min="0" step="0.01" :value="getLayerParams(design).top" class="no-validation" color="blue" outlined label="Top">
                                                                    <template v-slot:append>
                                                                        <span class="fs-14 fw-400">%</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                        </div>
                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Align</p>
                                                            </div>
                                                            <div class="col-md-8 pl-0">
                                                                <div class="d-flex flex-row justify-space-between w-100">
                                                                    <v-img @click="alignLayer(design,align)" class="hover" max-width="24px" max-height="24px" :src="$root.getSrc('/default/drop_icons/'+align+'.svg')" contain v-for="align in alignment"></v-img>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="d-flex flex-row w-100 justify-space-between align-center">
                                                        <div class="d-flex flex-child  w-100 flex-row align-center">
                                                            <div v-if="!mode" class="d-flex flex-column justify-space-around mr-2">
                                                                <v-img v-if="index==0" class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_up.svg')" contain ></v-img>
                                                                <v-img v-else @click="moveUpGraphic(design.id)" class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_up_enabled.svg')" contain ></v-img>
                                                                <v-img v-if="index+1 < layers.length" @click="moveDownGraphic(design.id)" class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_down.svg')" contain ></v-img>
                                                                <v-img v-else class="hover" max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/arrow_down_disabled.svg')" contain ></v-img>
                                                            </div>
                                                            <v-img  @click="$set(design,'expanded', !design.expanded)" class="hover" max-width="32px" max-height="32px" :src="$root.getSrc('/default/text.svg')" contain ></v-img>

                                                            <div @click="$set(design,'expanded', !design.expanded)" class="ml-3 d-flex flex-column hover">
                                                                <span class="fs-16 fw-600 flex-child">{{ design.text }}</span>
                                                            </div>
                                                        </div>

                                                        <div v-if="!mode" class="d-flex justify-end" style="height: 100%;">
                                                            <v-img @click="deleteTextLayer(design.id)" class="hover" max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/trash.svg')" contain></v-img>
                                                        </div>
                                                    </div>
                                                    <div v-if="design.expanded && !mode">
                                                        <div class="row pl-4 pr-4  pt-4">
                                                            <v-text-field label="Text" class="no-validation" color="blue" outlined v-model="design.text"></v-text-field>
                                                        </div>
                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-5 pl-0">
                                                                <div @click="changeText = true; textType='family'; selectedTextLayer = design" class="d-flex align-center justify-space-between hover" style="border: 1px solid #828282; border-radius: 8px; width: 100%; height: 100%; padding-right: 12px; padding-left: 12px;">
                                                                    <span class="fw-400 fs-14">{{getLayerParams(design).fontFamily}}</span>
                                                                    <v-img max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/edit_pencil.svg')" contain ></v-img>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-5 pl-0">
                                                                <div @click="changeText = true; textType='color'; selectedTextLayer = design"  class="d-flex align-center justify-space-between hover" style="border: 1px solid #828282; border-radius: 8px; width: 100%; height: 100%; padding-right: 12px; padding-left: 12px;">
                                                                    <div style="width: 19px; height: 19px; border-radius: 10px; border: 1px solid black;" :style="{'backgroundColor': getLayerParams(design).fill}"></div>
                                                                    <span class="fw-400 fs-14">Color</span>
                                                                    <v-img max-width="16px" max-height="16px" :src="$root.getSrc('/default/drop_icons/edit_pencil.svg')" contain ></v-img>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <v-text-field style="visibility: hidden;" outlined class="no-validation"></v-text-field>
                                                            </div>
                                                        </div>
                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Size</p>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field type="number" @change="updateLayerValue($event,design,'height')" min="0" step="0.01" :value="getLayerParams(design).height" class="no-validation" color="blue" outlined label="Height">
                                                                    <template v-slot:append>
                                                                        <span style="white-space:nowrap;" class="fs-14 mt-2 fw-400">cm</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field type="number" @change="updateLayerValue($event,design,'width')" min="0" step="0.01" :value="getLayerParams(design).width" class="no-validation" color="blue" outlined label="Width">
                                                                    <template v-slot:append>
                                                                        <span style="white-space:nowrap;" class="fs-14 mt-2 fw-400">cm</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                        </div>
                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Transform</p>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field  type="number" @change="updateLayerValue($event,design,'rotation')" min="0" step="0.01" max="360" :value="getLayerParams(design).rotation" class="no-validation" color="blue" outlined label="Rotate">
                                                                    <template v-slot:append>
                                                                        <span style="white-space:nowrap;" class="fs-14 fw-400">deg</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                        </div>

                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Position</p>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field  type="number" @change="updateLayerValue($event,design,'left')" min="0" step="0.01" class="no-validation" :value="getLayerParams(design).left" color="blue" outlined label="Left">
                                                                    <template v-slot:append>
                                                                        <span class="fs-14 fw-400">%</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                            <div class="col-md-4 pl-0">
                                                                <v-text-field type="number" @change="updateLayerValue($event,design,'top')" min="0" step="0.01" class="no-validation" :value="getLayerParams(design).top" color="blue" outlined label="Top">
                                                                    <template v-slot:append>
                                                                        <span class="fs-14 fw-400">%</span>
                                                                    </template>
                                                                </v-text-field>
                                                            </div>
                                                        </div>
                                                        <div class="row pl-4 pr-4">
                                                            <div class="col-md-4 pr-0 d-flex justify-start align-center">
                                                                <p class="ma-0 fs-14 fw-600">Align</p>
                                                            </div>
                                                            <div class="col-md-8 pl-0">
                                                                <div class="d-flex flex-row justify-space-between w-100">
                                                                    <v-img @click="alignLayer(design,align)" class="hover" max-width="24px" max-height="24px" :src="$root.getSrc('/default/drop_icons/'+align+'.svg')" contain v-for="align in alignment"></v-img>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div v-else-if="type=='text'">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex flex-row">
                                                    <secondary-button style="width: 100%!important;;"  :fullWidth="true" @clickBtn="addNewText" :activeButton="textInput.length > 0">Add new text</secondary-button>
                                                </div>
                                                <v-text-field class="mt-2 no-validation" :maxlength="100" height="90px" outlined color="#4353FF" v-model="textInput" label="Text input"></v-text-field>
                                                <div class="row mt-3">
                                                    <div class="col-md-6 d-flex flex-column">
                                                        <span class="fs-12 kanit-normal">FONT</span>
                                                        <v-select :menu-props="{'offset-y': true}"  outlined color="#4353FF" v-model="fontFamily" :items="fontFamilies">
                                                            <template slot="item" slot-scope="data">
                                                                <span :class="data.item">{{data.item.charAt(0).toUpperCase() + data.item.slice(1)}}</span>
                                                            </template>
                                                            <template slot="selection" slot-scope="data">
                                                                <span :class="data.item">{{data.item.charAt(0).toUpperCase() + data.item.slice(1)}}</span>
                                                            </template>
                                                        </v-select>

                                                    </div>
                                                    <div class="col-md-6 d-flex flex-column">
                                                        <span class="fs-12 kanit-normal">COLOUR</span>
                                                        <v-select :menu-props="{'offset-y': true}"  outlined color="#4353FF" v-model="fill" :items="colorArr">
                                                            <template slot="item" slot-scope="data">
                                                                <span style="width: 16px; height: 16px; border-radius: 100%;" :style="{background: data.item}"></span>
                                                                <span class="ml-2">{{data.item}}</span>
                                                            </template>
                                                            <template slot="selection" slot-scope="data">
                                                                <span style="width: 16px; height: 16px; border-radius: 100%;" :style="{background: data.item}"></span>
                                                                <span class="ml-2">{{data.item}}</span>
                                                            </template>
                                                        </v-select>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div v-else>
                                            <div class="d-flex flex-column">
                                                <secondary-button style="width: 100%!important;;" :fullWidth="true" @clickBtn="addNewDesign" :activeButton="owner">Add new design</secondary-button>
                                                <div class="d-flex flex-column ">
                                                    <div style="position: relative" class="dashed-input d-flex flex-row justify-center align-center mt-3 hover">
                                                        <v-img v-if="!is_image_uploading" class="mt-8 mb-8 mr-3" max-height="24px" max-width="24px" :src="$root.getSrc('/default/download_icon_2.svg')" contain></v-img>
                                                        <v-progress-circular v-else :size="24" color="primary" class="loading mt-8 mb-8 mr-3" indeterminate/>
                                                        <span class="fs-16 kanit-normal">{{is_image_uploading ? 'Uploading' : 'Upload design from disk'}}</span>
                                                        <div class="dashed-input-white" style="position: absolute; top:0; left: 0; height: 100%; width: 100%;">
                                                            <input @input="onFileChange($event)" type="file" id="file_input_new" style="display: none" ref="file_input_new">
                                                            <v-btn @click="$refs.file_input_new.click()" style="position: absolute; top:0; left: 0; height: 100%; width: 100%; border: 0;" v-ripple="false" @drop.stop.prevent="drop" @dragover="dragging = true" @dragover.stop.prevent="dragging = true" @dragleave.stop.prevent="dragging=false" :class="{'dragging': dragging}" tile outlined min-height="80px" class="w-100"></v-btn>
                                                        </div>
                                                    </div>
                                                    <v-checkbox
                                                        v-if="imageUrl"
                                                        class="no-validation mt-3"
                                                        v-model="owner"
                                                        color="#2F80ED"
                                                        label="I have rights for this graphic or I'm an author of this graphic"
                                                    ></v-checkbox>
                                                    <div class="mt-3 d-flex flex-column" v-if="imageUrl" style="max-width: 120px">
                                                        <span class="kanit-bold fs-18">Design</span>
                                                        <v-img :src="$root.getSrc(imageUrl)" max-width="120px" max-height="80px" contain></v-img>
                                                        <p v-if="file_name" class="mb-0 mt-2 kanit-normal">{{ file_name }}</p>
                                                        <p v-if="file_size" class="mt-2 mb-2 kanit-normal-2">{{ file_size }}</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <v-expansion-panels @clik="titlePanel = 1" style="position: relative;" class="right-container" >
                                <v-expansion-panel class="elevation-0 ml-5">
                                    <v-expansion-panel-header>
                                        <template v-slot:actions>
                                            <v-icon class="icon-reverse">$expand</v-icon>
                                        </template>
                                        <div class="d-flex header-reverse flex-column">
                                            <span class="kanit-bold fs-24 ml-5">Product information</span>
                                            <span class="kanit-normal fs-16 mt-3 ml-5">Put some information about your product</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content v-show="titlePanel == 1" class="pl-0" eager>
                                        <my-form ref="product">
                                            <div class="">
                                                <span class="fs-24 mb-4 kanit-normal">Title and description</span>
                                                <v-text-field
                                                    outlined
                                                    label="Product title"
                                                    v-model="product.name"
                                                    @change="setSlug($event)"
                                                    :rules="[validationRules.required]"
                                                    color="blue"
                                                ></v-text-field>
                                                <v-text-field
                                                    outlined
                                                    label="Url"
                                                    v-model="product.slug"
                                                    @change="setSlug($event)"
                                                    color="blue"
                                                    :rules="[validationRules.required]"
                                                ></v-text-field>
                                                <v-textarea
                                                    outlined
                                                    label="Description"
                                                    v-model="product.desc"
                                                    color="blue"
                                                ></v-textarea>
                                                <v-text-field
                                                    v-if="false"
                                                    class="no-validation"
                                                    outlined
                                                    label="Tags"
                                                    v-model="product.tags"
                                                    color="blue"
                                                ></v-text-field>
                                            </div>
                                        </my-form>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                            <v-expansion-panels v-show="product && product.product_integrations && product.product_integrations.length > 0" @clik="titlePanel = 2" style="position: relative;" class="right-container" >
                                <v-expansion-panel class="elevation-0 ml-5">
                                    <v-expansion-panel-header>
                                        <template v-slot:actions>
                                            <v-icon class="icon-reverse">$expand</v-icon>
                                        </template>
                                        <div class="d-flex header-reverse flex-column">
                                            <span class="kanit-bold fs-24 ml-5">Shopify configuration</span>
                                            <span class="kanit-normal fs-16 mt-3 ml-5">Set which attributes should be synced</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content v-show="titlePanel == 2" class="pl-0" eager>
                                        <div class="pl-2">
                                            <v-switch
                                                color="blue"
                                                label="Sync images to Shopify"
                                                class="no-validation mb-3"
                                                v-model="product.update_integration_images"
                                            ></v-switch>
                                            <v-switch
                                                color="blue"
                                                label="Sync name to Shopify"
                                                class="no-validation mb-3"
                                                v-model="product.update_integration_name"
                                            ></v-switch>
                                            <v-switch
                                                color="blue"
                                                label="Sync description to Shopify"
                                                class="no-validation mb-3"
                                                v-model="product.update_integration_desc"
                                            ></v-switch>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <v-expansion-panels @clik="titlePanel = 3" style="position: relative;"  class="right-container">
                                <v-expansion-panel class="elevation-0 ml-5">
                                    <v-expansion-panel-header>
                                        <template v-slot:actions>
                                            <v-icon class="icon-reverse">$expand</v-icon>
                                        </template>
                                        <div class="d-flex header-reverse flex-column">
                                            <span class="kanit-bold fs-24 ml-5">Price</span>
                                            <span class="kanit-normal fs-16 mt-3 ml-5">Set up your price margin</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content v-show="titlePanel == 3" eager>
                                        <div class="ml-5">
                                            <span class="fs-24 mb-4 kanit-normal">Price</span>
                                        </div>
                                        <div class="ml-5 row">
                                            <div class="col-md-6 pl-0 pb-0">
                                                <v-text-field
                                                    dense
                                                    outlined
                                                    label="Retail price from (AUD)"
                                                    type="number"
                                                    step="0.01"
                                                    :value="parseFloat(lowestPrice).toFixed(2)"
                                                    color="blue"
                                                    disabled
                                                ></v-text-field>
                                            </div>
                                            <div class="col-md-6 pr-0 pb-0">
                                                <v-text-field
                                                    dense
                                                    outlined
                                                    label="Margin (AUD)"
                                                    v-model="product.price"
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    color="blue"
                                                >
                                                    <template v-slot:append>
                                                        <span style="white-space:nowrap;"  class="mt-1">AUD</span>
                                                    </template>
                                                </v-text-field>
                                            </div>

                                            <div class="col-md-12 d-flex align-center justify-space-between pb-2 pt-0 pl-0 pr-0" style="border-bottom: 1px solid #BDBDBD;">
                                                <span class="fs-14 fw-400 blue-drop pl-0 pr-0">Cost to you</span>
                                                <span class="fs-18 fw-500">{{ parseFloat(lowestPrice).toFixed(2) }} AUD</span>
                                            </div>
                                            <div class="col-md-12 d-flex justify-space-between align-center pt-2 pl-0 pr-0">
                                                <span class="fs-14 fw-400 blue-drop pl-0 pr-0">Cost to customer</span>
                                                <span class="fs-18 fw-500">{{ (parseFloat(product.price) + parseFloat(lowestPrice)).toFixed(2)  }}  AUD</span>
                                            </div>

                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                        </div>
                        <div class="ml-5 d-flex flex-column" v-else-if="product && productDetails">
                            <p class="fw-400 fs-24 mb-3">Product description</p>
                            <p v-html="product.additional_description" class="fw-400 fs-18"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="newProduct">
        <div class="box-shadow smake">
            <div class="container pa-0">
                <div class="page d-flex flex-wrap">
                    <div class="col-12 col-xs-12 pb-8 pt-8 col-sm-12 col-md-8 col-lg-8 d-flex justify-space-between"
                         style="border-right: 1px solid #E0E0E0;">
                        <div class="d-flex row justify-space-between align-center flex-wrap">
                            <div
                                class="col-12 pr-0 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex flex-row left-arrow row justify-start align-center flex-wrap">
                                <v-img @click="$router.push('/products')" class="hover" max-height="30px"
                                       max-width="28px" :src="$root.getSrc('/default/drop_icons/left_arrow.svg')"
                                       contain></v-img>
                                <div class="d-flex flex-column justify-start ml-5">
                                <span class="fs-32 fw-600">
                                    Create new product
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="product-details-border d-flex justify-end align-center col-xs-12 col-sm-12 col-md-4 col-lg-4 product-details-header align-center pl-5">
                    </div>
                </div>
            </div>
        </div>
        <div v-if="step == 1" class="container">
            <div class="row  mt-16" style="margin-bottom: 100px;">
                <div class="col-md-12 ma-0 d-flex align-center justify-space-between">
                    <h1 class="kanit-bold" style="font-size: 48px;">Add your design</h1>
                    <primary-button class="mt-2" @clickBtn="step = 2" :active-button="designOwner">Next</primary-button>
                </div>
                <div class="col-md-6">
                    <div style="width: 85%;">
                        <p class="mt-5 mb-0 kanit-normal" style="font-size: 18px;">Supported formats: <span class="kanit-bold pink-color-text">PNG, JPG</span> and <span class="kanit-bold pink-color-text">SVG</span></p>
                        <p class="mt-3 mb-0 kanit-normal" style="font-size: 18px;">For optimum quality we recommend upload your vector graphic or images with a minimum resolution of 2400px x 3300px at 300dpi. This ensures that your design will look amazing!</p>
                        <p class="mt-3 mb-0 kanit-normal" style="font-size: 18px;">Maximum file size is <span class="kanit-bold pink-color-text">30 MB</span></p>
                        <p class="mt-5 mb-0 kanit-normal" style="font-size: 14px;">In the next step you will have possibility to add text and arrange your graphic on chosen products</p>
                    </div>
                </div>
                <div style="position:relative;" @drop="uploadProductionPhotoNewProduct" v-if="!file_name" class="col-md-6 dashed-input d-flex justify-space-between align-center flex-column">
                    <div class="dashed-input-white" style="position: absolute; top:0; left: 0;  width: 100%;height: 100%;">
                        <input @input="uploadProductionPhotoNewProduct($event)" type="file" id="file_input" style="display: none" ref="file_input">
                        <v-btn @click="$refs.file_input.click()" style="position: absolute; top:0; left: 0; height: 100%; width: 100%; border: 0;" v-ripple="false" @drop.stop.prevent="drop" @dragover="dragging = true" @dragover.stop.prevent="dragging = true" @dragleave.stop.prevent="dragging=false" :class="{'dragging': dragging}" tile outlined min-height="120px" class="w-100">
                        </v-btn>
                    </div>
                    <v-img class="mt-5" max-height="48px" :src="$root.getSrc('/default/download_icon_2.svg')" contain></v-img>
                    <h2 class="kanit-bold">Upload your design</h2>
                    <div class="d-flex justify-center align-center flex-column">
                        <p class="mb-0 kanit-normal">Drag and drop your project here</p>
                        <p class="mb-0 kanit-normal">or</p>
                    </div>
                    <span @click="$refs.production_photo.click()" class="fs-18 kanit-bold mb-10" style="color: #4353FF!important;">Select from disk</span>
                    <input type="file" accept="image/*" multiple @input="uploadProductionPhotoNewProduct($event)" ref="production_photo" style="display: none" />
                    <p v-if="wrongSize" style="color: red;">
                        Maximum file size is 30 MB!
                    </p>
                </div>
                <div  class="col-md-6 d-flex  align-center flex-column" v-else>
                    <div style="position:relative; width: 100%"  class="dashed-input d-flex justify-space-between align-center flex-column" @drop="uploadProductionPhotoNewProduct">
                        <div class="dashed-input-white" style="position: absolute; top:0; left: 0; height: 100%; width: 100%;">
                            <input @input="uploadProductionPhotoNewProduct($event)" type="file" id="file_input_2" style="display: none" ref="file_input_2">
                            <v-btn @click="$refs.file_input_2.click()" style="position: absolute; top:0; left: 0; height: 100%; width: 100%; border: 0;" v-ripple="false" @drop.stop.prevent="drop" @dragover="dragging = true" @dragover.stop.prevent="dragging = true" @dragleave.stop.prevent="dragging=false" :class="{'dragging': dragging}" tile outlined min-height="120px" class="w-100">
                            </v-btn>
                        </div>
                        <div class="mt-10">
                            <v-img style="position: relative" class="mt-5" max-height="240px" max-width="240px" :src="$root.getSrc(production_photo)" contain>
                                <v-img @click="deleteImage" class="hover" style="position: absolute; right: 0; top: 0; z-index: 999;" max-height="32px" max-width="32px" :src="$root.getSrc('/default/trash_circle.svg')" contain></v-img>
                            </v-img>
                        </div>
                        <div class="d-flex mt-5 mb-5 justify-space-between align-center flex-column">
                            <p class="mb-0">{{ file_name }}</p>
                            <p class="mt-2 mb-2">{{ file_size }}</p>
                        </div>
                        <p v-if="wrongSize" style="color: red;">
                            Maximum file size is 30 MB!
                        </p>
                    </div>
                    <v-checkbox
                        class="no-validation mt-3"
                        v-model="designOwner"
                        color="#2F80ED"
                        label="I have rights for this graphic or I'm an author of this graphic"
                    ></v-checkbox>
                </div>
            </div>
        </div>
        <div v-if="step == 2" class="container mt-5">
            <div class="row">
                <div v-if="smakeProducts" class="col-sm-6 col-xs-6 col-md-4 col-lg-3" v-for="(product, index) in smakeProducts">
                    <smake-product @selectProduct="selectProduct" :product="product" :production_full_path_url="production_full_path_url" :fileWidth="fileWidth" :fileHeight="fileHeight" ></smake-product>
                </div>
                <div v-if="false" class="product-container smake-product-container d-flex flex-column" style="position:relative; height:100%; min-width:190px;">
                    <div class="d-flex justify-center align-center">
                        <v-img :id="product.id" style="z-index: 0; top:20px; position: absolute;" max-width="180px" max-height="180px" :src="$root.getSrc('/'+ product.photos)" contain></v-img>
                    </div>
                    <div class="d-flex flex-column" style="margin-top: 135px; height:100%; background-color: white; justify-content: space-between; border-top: 1px solid #E0E0E0; z-index: 9;">
                        <p class="kanit-bold ma-0 fs-18">{{ product.name }}</p>
                        <p v-if="colorSwatchesCircle(product) && colorSwatchesCircle(product).length>0" class="kanit-normal mt-1 mb-0 fs-14">Colours</p>
                        <div>
                            <div class="swatch-circle mr-1" v-for="swatch in colorSwatchesCircle(product)">
                                <v-img style="border-radius: 100%;" width="100%" height="100%" contain :src="getSrc(swatch)"></v-img>
                            </div>
                        </div>
                        <p class="kanit-bold fs-14">From {{ getLowestPrice(product)}} AUD</p>
                        <div class="d-flex justify-end mt-2">
                            <primary-button @clickBtn="selectProduct(product)" :activeButton="true">Create</primary-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getBread} from "@/api/bread";
import Konva from "konva";
import {imageData, dataURItoBlob, slugify} from "@/helpers";
import config from "@/config";
import {upload, uploadAndChangeDPI} from "@/api/upload";
import {updateProduct, getProductsToFirstProduct, storeProduct, storePhotoUri, validateUrl} from "@/api/products";
import {getCategories} from "@/api/categories";
import SmakeProduct from './smake-product'
export default {
    components:{SmakeProduct},
    data:() => {
        return{
            options: [
                {
                    'text': 'Design',
                    'image': 'logo_and_banner.svg',
                    'type': 'design'
                },
                {
                    'text': 'Text',
                    'image': 'text.svg',
                    'type': 'text'
                },
                {
                    'text': 'Layer',
                    'image': 'layers.svg',
                    'type': 'layer'
                }
            ],
            type:'design',
            product: null,
            printImages: [],
            activeSide: 'front',
            imageUrl: null,
            configKonva: null,
            background: null,
            owner: false,
            saving: false,
            previewMode: false,
            refreshProject: false,
            fetching_file: false,
            changedSide: false,
            mode: false,
            selectedVariantImage: null,
            layers: [],
            config: null,
            front_print_config: null,
            back_print_config: null,
            transformer: null,
            layersReverted: [],
            colorSwatches: [],
            colors: [],
            selectedColors: [],
            selectedColorsName: [],
            productDetails: false,
            is_image_uploading: false,
            selectedColor: null,
            textInput: '',
            fill: '#201F1F',
            fontFamily: 'kanit',
            editColors: false,
            addLayer: false,
            changeText: false,
            textType: null,
            panel: 0,
            designPanel: null,
            selectedTextLayer: null,
            fontFamilies: ['roboto','montserrat','kanit','judson'],
            colorArr:['#201F1F','#9B51E0','#F2994A','#56CCF2','#F2C94C','#6FCF97','#219653','#EB5757','#2D9CDB','#2F80ED','#F2F2F2','#E0E0E0','#BDBDBD','#828282','#4F4F4F'],
            specificColor: null,
            design: null,
            firstLaunch: true,
            mockup_files: {},
            production_photos: {},
            generatedVariants: [],
            variants: [],
            sides: [],
            createLayer: true,
            finished: false,
            newProduct: false,
            file_name: null,
            designOwner: false,
            step: 1,
            production_photo: null,
            production_full_path_url: null,
            fileWidth: null,
            fileHeight: null,
            dragging: false,
            file_size: null,
            category: 'all products',
            allProducts: 0,
            categoriesWithQuantity: [],
            products: null,
            allSmakeProducts: [],
            wait: true,
            alignment: ['align_left', 'align_center_2', 'align_right', 'align_top', 'align_center_1' ,'align_bottom'],
            creating: false,
            loading: false,
            wrongSize: false,
            allCategories: [],
            changedDesign: false,
            width: 0,
            titlePanel: null,
            specificDesignForColor: false,
        }
    },
    created() {
        window.addEventListener("resize", this.getWidth);
    },
    computed:{
        clippingConfig(){
            let foundVariant;
            if(this.background){
                let printArea;
                this.product.product.print_areas.forEach(print=>{
                    if(print.side == this.activeSide) printArea = print.data;
                })

                if(printArea){
                    let ratioW = this.background.width/printArea.canvasWidth;
                    let ratioH = this.background.height/printArea.canvasHeight;
                    let obj = {
                        x: 0,
                        y: 0,
                        width: this.background.width,
                        height: this.background.height,
                        stroke: 'gray',
                        strokeWidth: 2,
                        dash: [10, 10],
                        clipX: ratioW*printArea.x,
                        clipY: ratioH*printArea.y,
                        clipWidth: ratioW*printArea.width,
                        clipHeight: ratioH*printArea.height,
                        heightInches: printArea.heightInches,
                        widthInches: printArea.widthInches,
                    };

                    this.front_print_config = obj;
                    return obj;
                }


            }

            let size =  document.getElementById('konva-wrapper').offsetWidth;
            if(size > 650) size = 650;

            let obj = {
                x: 0,
                y: 0,
                width: size,
                height: size,
                clipX: 0,
                clipY: 0,
                stroke: 'gray',
                strokeWidth: 2,
                dash: [10, 10],
                clipWidth: size,
                clipHeight: size,
                originalX: 0,
                originalY: 0
            }

            this.back_print_config = obj;
            this.front_print_config = obj;
            return obj;
        },
        backgroundConfig() {
            if (this.background) {
                var larger = null;
                (this.background.width > this.background.height) ? larger = 'width' : larger = 'height';
                var ratio = this.configKonva[larger] / this.background[larger];
                var obj = this.background;
                obj.width = obj.width * ratio;
                obj.height = obj.height * ratio;
                obj.x = (this.configKonva.width - obj.width) / 2;
                return obj
            }
            return {}
        },
        rectConfig(){
            let obj = {
                x: this.clippingConfig.clipX,
                y: this.clippingConfig.clipY,
                width: this.clippingConfig.clipWidth,
                height: this.clippingConfig.clipHeight,
                stroke: 'gray',
                strokeWidth: 2,
                dash: [10, 10],
            };
            this.config = obj

            return obj;
        },
        rectConfigOutline(){
            return {
                x: this.clippingConfig.clipX,
                y: this.clippingConfig.clipY,
                width: this.clippingConfig.clipWidth,
                height: this.clippingConfig.clipHeight,
                stroke: 'white',
                strokeWidth: 2,
                dash: [10, 10],
            }
        },
        color(){
            return this.selectedColor;
        },
        selectedlayersReverted(){
            let layerArr = [];
            if(this.layersReverted){
                this.layersReverted.forEach(layer=>{
                    if(layer.side == this.activeSide){
                        if(layer.specificColor && layer.specificColor == this.selectedColor){
                            layerArr.push(layer);
                        } else if(!layer.specificColor){
                            layerArr.push(layer);
                        }
                    }
                })
            }
            return layerArr;
        },
        selectedLayers(){
            let layerArr = [];
            if(this.layers){
                this.layers.forEach(layer=>{
                    if(layer.side == this.activeSide){
                        if(layer.specificColor && layer.specificColor == this.selectedColor){
                            layerArr.push(layer);
                        } else if(!layer.specificColor){
                            layerArr.push(layer);
                        }
                    }
                })
            }
            return layerArr;
        },
        smakeProducts(){
            if(this.category == 'all products') return this.allSmakeProducts;
            if(this.allSmake) return this.allSmake[this.category];
            return null;
        },
        smakeVariants(){
            if(!this.product || !this.product.product || !this.product.product.data || !this.product.product.data.variants) return null;
            var colors = {};
            this.product.product.data.variants.forEach(item => {
                var finded = item.attributes.find(x => x.name == 'color');
                if(finded){
                    var size = item.attributes.find(x => x.name == 'size');
                    if(item.images && item.images.length > 0){
                        if(!colors[finded.value]) colors[finded.value] = {sizes:[], color: finded.value, image: item.images[0].image};
                    } else {
                        if(!colors[finded.value]) colors[finded.value] = {sizes:[], color: finded.value, image: null};
                    }

                    if(!colors[finded.value].sizes.find(x => x == size.value)) colors[finded.value].sizes.push(size.value);
                }
            })
            const ordered = Object.keys(colors).sort().reduce(
                (obj, key) => {
                    obj[key] = colors[key];
                    return obj;
                },
                {}
            );
            return ordered;
        },
        getSidesAmount(){
            let layers = [];
            this.layers.forEach(lay=>{
                if(layers.indexOf(lay.side) < 0) layers.push(lay.side);
            })
            return layers.length > 0 ? layers.length : 1;
        },
        lowestPrice(){
            let price = 9999;
            if(this.product && this.product.product){
                this.product.product.data.variants.forEach(variant=>{
                    if(price > variant.total) price = variant.total;
                })
                price = parseFloat(price)+parseFloat(this.getSidesAmount*this.product.product.print_price);
            }
            return price.toFixed(2);
        },
    },
    mounted(){
        this.getWidth();
        this.getCategories();
        if(this.$route.params.id){
            this.firstLaunch = false;
            this.getProduct();
        } else {
            this.initNewProduct();
        }
    },
    methods:{
        onFileChange(event){
            this.loading = true;
            this.is_image_uploading = true;
            var formData = new FormData();
            var index = 0;
            var files = event.target.files || event.dataTransfer.files;
            formData.append('skipOwner', true);
            for(var i in files){
                formData.append('files['+index+']', files[i]);
                if(files[i].size){
                    this.file_size = this.formatBytes(files[i].size);
                }
                index++;
            }

            upload(formData, 'first_products_mockup').then(response => {
                this.loading = false;
                this.imageUrl = response.data[0];
                this.file_name = response.file_name;
                this.is_image_uploading = false;
            })
        },
        addNewDesign(){
            this.setProjectConfig(this.imageUrl, this.specificDesignForColor ? this.selectedColor : null, true);
            this.initDesign()
        },
        addNewText(){
            this.addTextLayerMethod(this.specificDesignForColor ? this.selectedColor : null, this.textInput.charAt(0).toUpperCase() + this.textInput.slice(1), this.fontFamily, this.fill, true);
            this.initText();
        },
        initText(){
            this.fill = '#201F1F';
            this.fontFamily = 'kanit';
            this.textInput = '';
        },
        initDesign(){
            this.imageUrl = null;
            this.owner = false;
        },
        deleteImage(){
            this.file_name = null;
            this.file_size = null;
            this.production_photo = null;
            this.production_url = null;
            this.production_full_path_url = null;
            this.designOwner = false;
        },
        getWidth(){
            this.width = window.innerWidth;
        },
        getCategories(){
            getCategories().then(response => {
                this.allCategories = response;
            })
        },
        getLowestProductPrice(){
            let price = 9999;
            if(this.product && this.product.product){
                this.product.product.data.variants.forEach(variant=>{
                    if(price > variant.total) price = variant.total;
                })
                price = parseFloat(price)+parseFloat(this.getSidesAmount*this.product.product.print_price);
            }
            return price.toFixed(2);
        },
        setSlug(string){
            this.$set(this.product, 'slug', slugify(string));
        },
        colorSwatchesCircle(product){
            let colorSwatches = [];
            let variants = product.data.variants;
            variants.forEach(variant=>{
                if(variant.color_swatch){
                    if(colorSwatches.indexOf(variant.color_swatch) < 0) colorSwatches.push(variant.color_swatch);
                }

            })
            return colorSwatches;
        },
        getLowestPrice(product){
            let price = 9999;
            product.data.variants.forEach(variant=>{
                if(price > variant.total) price = variant.total;
            })
            price = parseFloat(price) + parseFloat(product.print_price);
            return price;
        },
        alignLayer(layer, type){
            this.changedDesign = true;
            if(type=='align_left'){
                layer.x = this.front_print_config.clipX;
            } else if(type == 'align_right'){
                let width;
                if(layer.type == 'text'){
                    const transformerNode = this.transformer.getNode();
                    const stage = transformerNode.getStage();
                    const stage_elem = stage.findOne('#'+layer.id);
                    width = stage_elem.width();
                } else {
                    width = layer.width * layer.scaleX;
                }
                layer.x = this.front_print_config.clipX + this.front_print_config.clipWidth - width;
            } else if(type == 'align_center_2'){
                let width;
                if(layer.type == 'text'){
                    const transformerNode = this.transformer.getNode();
                    const stage = transformerNode.getStage();
                    const stage_elem = stage.findOne('#'+layer.id);
                    width = stage_elem.width();
                } else {
                    width = layer.width * layer.scaleX;
                }
                width = this.front_print_config.clipWidth - width;
                layer.x = this.front_print_config.clipX + width/2;
            } else if(type == 'align_top'){
                layer.y = this.front_print_config.clipY;
            } else if(type =='align_center_1'){
                let height;
                if(layer.type == 'text'){
                    const transformerNode = this.transformer.getNode();
                    const stage = transformerNode.getStage();
                    const stage_elem = stage.findOne('#'+layer.id);
                    height = stage_elem.height();
                } else {
                    height = layer.height * layer.scaleY;
                }

                height = this.front_print_config.clipHeight - height;
                layer.y = this.front_print_config.clipY + height/2;
            } else if(type == 'align_bottom'){
                let height;
                if(layer.type == 'text'){
                    const transformerNode = this.transformer.getNode();
                    const stage = transformerNode.getStage();
                    const stage_elem = stage.findOne('#'+layer.id);
                    height = stage_elem.height();
                } else {
                    height = layer.height * layer.scaleY;
                }
                layer.y = this.front_print_config.clipY + this.front_print_config.clipHeight - height;
            }
        },
        selectProduct(product){
            this.product = {
                name: 'Product',
                desc: '',
                tags: '',
                price: 0,
                variants: [],
                preview_photos:[],
                production_photos: {},
                available: true,
                slug: 'Product-'+this.makeid(5),
                mockup_files: {},
                print_method: 'dtg',
                is_published: 1,
                generatedVariants: [],
                product: product
            }
            this.printImages = product.data.variants[0].images;
            this.setSides();
            this.setColorSwatches();
            setTimeout(()=>{
                this.getBackgroundImage();
            },200)
        },
        changeActiveCategory(category){
            this.category = category;
        },
        drop(event){
            this.dragging = false;
            var event2 = event.originalEvent || event;
            this.uploadProductionPhotoNewProduct(event2);
        },
        initNewProduct(){
            this.newProduct = true;
            this.titlePanel = 0;
            getProductsToFirstProduct().then(res=>{
                this.allProducts = res.allProducts;
                this.allSmake = res.products;

                for (const [key, value] of Object.entries(res.products)) {
                    this.categoriesWithQuantity.push({
                        'name': key,
                        'quantity': value.length
                    })

                    value.forEach(val=>this.allSmakeProducts.push(val));
                }

            })
        },
        formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        uploadProductionPhotoNewProduct(event){
            this.loading = true;
            this.wrongSize = false;
            var formData = new FormData();
            var index = 0;
            var files = event.target.files || event.dataTransfer.files;
            formData.append('skipOwner', true);
            for(var i in files){
                formData.append('files['+index+']', files[i]);
                if(files[i].size){
                    this.file_size = this.formatBytes(files[i].size);
                }
                index++;
            }

            upload(formData, 'first_products_mockup').then(response => {
                this.$set(this,'production_photo', response.data[0]);
                this.$set(this,'production_full_path_url', response.fullpath);
                this.$set(this,'file_name', response.file_name);
                this.$set(this,'fileWidth', response.width);
                this.$set(this,'fileHeight', response.height);
                this.loading = false;
            }).catch(e=>{
                this.file_size = null;
                this.wrongSize = true;
            })

        },
        isLayer(side){
            let isSide = false;
            this.layers.forEach(layer=>{
                if(layer.side == side) isSide = true;
            })
            return isSide;
        },
        layerHasCustomDesign(side, color){
            let isSide = false;
            this.layers.forEach(layer=>{
                if(layer.side == side){
                    if(layer.specificColor && layer.specificColor == color){
                        isSide = true;
                    }
                }
            })
            return isSide;
        },
        stageToImage(max_size=1000, return_uri = false, color){
            if(color){
                this.getBackgroundImage(color);
            }

            setTimeout(() => {
                if(this.saving) this.saving = false;
            },3000)

            return new Promise((resolve, reject) => {
                let nextPromiseJar = [];
                let tmp2 = new Promise((resolve, reject) => {
                    setTimeout(()=>{
                        resolve();
                    },200);
                })

                nextPromiseJar.push(tmp2);
                Promise.all(nextPromiseJar).then(res => {
                    this.previewMode = true;
                    this.saving = true;
                    this.selectedShapeName = null;
                    this.updateTransformer();
                    var originalKonva = this.configKonva;
                    var ratio = 1;
                    (this.configKonva.width > this.configKonva.height)? ratio = max_size / this.configKonva.width : ratio = max_size / this.configKonva.height;
                    if(ratio < 3) ratio = 3;
                    setTimeout(() => {
                        var dataURLFront = this.$refs.stage.getStage().toDataURL({pixelRatio: ratio});
                        if(return_uri){
                            resolve(dataURLFront);
                            return;
                        }
                        var formData = new FormData();
                        var blob = dataURItoBlob(dataURLFront);
                        formData.append("file", blob);
                        this.previewMode = false;
                        upload(formData, 'mocups').then(res => {
                            this.saving = false;
                            resolve(res.data[0]);
                            this.configKonva = originalKonva;
                        }).catch(e => {
                            this.saving = false;
                        })
                    },100);
                })


            })
        },
        async createSingleColor(){

        },
        updateProductInfo(){
            let categories = []
            this.product.categories.forEach(cat=>categories.push(cat.id ? cat.id : cat));
            this.product.categories = categories;

            var func = updateProduct(this.product.id, {...this.product, details: true});
            func.then(response => {
                this.saving = false;
                this.creating = false;
                let text = this.product.id ? 'updated' : 'created';
                this.$store.commit('app/ADD_MESSAGE', {text: 'Product successfully '+ text +'!', type:'success'});
                setTimeout(()=>{
                    this.$router.push('/products');
                },200);
            }).catch(e => {
                this.saving = false;
                this.creating = false;
                this.production_photos = {};
                this.generatedVariants = [];
                if(e.response.data.errors && e.response.data.errors.slug){
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Product with url '+this.product.slug+' already exist', type:'error'});
                } else {
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong...', type:'error'});
                }
            })
        },
        async updateDesign(){
            if(this.product.id){
                this.$store.commit('app/ADD_MESSAGE', {text: 'Updating Product!', type:'info'});
            } else {
                this.$store.commit('app/ADD_MESSAGE', {text: 'Creating Product!', type:'info'});
            }
            this.saving = true;
            this.creating = true;
            this.activeSide = 'front';
            let generatedVariants = this.generatedVariants;
            let production_photos = this.production_photos;
            let production_files = [];
            var nextPromiseJar = [];
            var tim = 1;

            this.product.preview_photos = [];

            let mockup_files = this.mockup_files;
            for(let i=0;i<this.product.product.print_areas.length;i++){
                await new Promise(async (resolveMain, reject)=>{
                    let print = this.product.product.print_areas[i];
                    if(this.isLayer(print.side)){
                        this.activeSide = print.side;
                        this.changedSide = true;
                        for (const item of this.selectedColors) {
                            var tmp = await new Promise((resolve, reject) => {
                                this.selectedColor = item.color_name;
                                this.getBackgroundImage(item.color_name).then(res => {
                                    setTimeout(()=>{
                                        this.stageToImage(1000, true, null).then(res => {
                                            let obj = {
                                                'color': item.color_name,
                                                'site': print.side,
                                                'photo_uri': res,

                                            }
                                            storePhotoUri(obj).then(resUri=>{
                                                obj = {
                                                    'color': item.color_name,
                                                    'site': print.side,
                                                    'mocup': resUri.mocup,
                                                    'path': resUri.path
                                                }
                                                generatedVariants.push(obj);

                                                if(this.layerHasCustomDesign(print.side,item.color_name) || !production_files[print.side]){
                                                    let config = {
                                                        pixelRatio: 30,
                                                        height: this.front_print_config.clipHeight,
                                                        width: this.front_print_config.clipWidth,
                                                        x: this.front_print_config.clipX,
                                                        y: this.front_print_config.clipY
                                                    };
                                                    var dataInitialFront = this.$refs.designMockup.getStage().toDataURL(config);
                                                    let blob2 = dataURItoBlob(dataInitialFront);
                                                    let formData2 = new FormData();
                                                    formData2.append("file", blob2);
                                                    let newSizes = {
                                                        'wantedHeight': null,
                                                        'wantedWidth': null
                                                    };
                                                    if(this.front_print_config.heightInches && this.front_print_config.widthInches){
                                                        newSizes = {
                                                            wantedHeight: (this.front_print_config.heightInches*118.1102362204724500).toFixed(2),
                                                            wantedWidth: (this.front_print_config.widthInches*118.110236220472450).toFixed(2),
                                                        }
                                                    }
                                                    uploadAndChangeDPI(formData2, 'product_production', newSizes.wantedWidth, newSizes.wantedHeight).then(res => {
                                                        if (!mockup_files[item.color_name]) mockup_files[item.color_name] = {};
                                                        if(!this.layerHasCustomDesign(print.side,item.color_name)) production_files[print.side] = res.dpi[0];
                                                        mockup_files[item.color_name][print.side] = res.dpi[0];
                                                        if (!production_photos[print.side]) {
                                                            var dataURLFront = this.$refs.stage.getStage().toDataURL({pixelRatio: 3});
                                                            var formDataa = new FormData();
                                                            let bloba2 = dataURItoBlob(dataURLFront);
                                                            formDataa.append("file", bloba2);
                                                            uploadAndChangeDPI(formDataa, 'mocups').then(res2 => {
                                                                if (this.product.preview_photos.length == 0) {
                                                                    this.product.preview_photos.push(res2.dpi[0]);
                                                                }
                                                                production_photos[print.side] = {
                                                                    'place': print.side,
                                                                    'file': res.dpi[0],
                                                                    'mocup': res2.dpi[0]
                                                                }
                                                                resolve();
                                                            })

                                                        } else {
                                                            resolve();
                                                        }
                                                    }).catch(e => {
                                                        this.creating = false;
                                                        this.saving = false;
                                                    })
                                                } else {
                                                    if (!mockup_files[item.color_name]) mockup_files[item.color_name] = {};
                                                    mockup_files[item.color_name][print.side] = production_files[print.side];
                                                    resolve();
                                                }


                                            })



                                        })
                                    },100)
                                });
                            })
                            nextPromiseJar.push(tmp);
                        }
                    }
                    Promise.all(nextPromiseJar).then(res => {
                        resolveMain();
                    })
                });
            }

            this.product.generatedVariants = generatedVariants;
            this.product.mockup_files = mockup_files;
            this.product.production_photos = production_photos;
            this.product.featured_front_image = this.product.preview_photos[0];
            this.product.layers = this.layers;


            if(this.product.id){
                var func = updateProduct(this.product.id, {...this.product, details: false});
            } else {
                this.product.product_id = this.product.product.id;
                var func = storeProduct({...this.product});
            }

            func.then(response => {
                this.saving = false;
                this.creating = false;
                let text = this.product.id ? 'updated' : 'created';
                this.$store.commit('app/ADD_MESSAGE', {text: 'Product successfully '+ text +'!', type:'success'});
                this.$store.getters.activeWebsite.amount_of_products++;
                setTimeout(()=>{
                    this.$router.push('/products');
                },200);
            }).catch(e => {
                this.saving = false;
                this.creating = false;
                this.production_photos = {};
                this.generatedVariants = [];
                if(e.response.data.errors && e.response.data.errors.slug){
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Product with url '+this.product.slug+' already exist', type:'error'});
                } else {
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong...', type:'error'});
                }
            })
        },
        updateProduct(){
            this.saving = true;
            this.creating = true;
            if(this.$refs.product.my_validate() && this.product.name.length > 0 && this.product.slug.length > 0){
                validateUrl(this.product).then(res=>{
                    if(this.changedDesign){
                        this.updateDesign();
                    } else {
                        this.updateProductInfo();
                    }
                }).catch(e => {
                    this.saving = false;
                    this.creating = false;
                    this.titlePanel = 1;
                    if(e.response.data.errors && e.response.data.errors.slug){
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Product with url '+this.product.slug+' already exist', type:'error'});
                    } else {
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong...', type:'error'});
                    }
                })
            } else {
                this.titlePanel = 1;
                this.$store.commit('app/ADD_MESSAGE', {text: 'Product name and url are required', type:'error'});

                this.saving = false;
                this.creating = false;
            }

        },
        uploadProductionPhoto(event){
            var formData = new FormData();
            var index = 0;
            var files = event.target.files || event.dataTransfer.files;
            formData.append('skipOwner', true);
            for(var i in files){
                formData.append('files['+index+']', files[i]);
                index++;
            }
            upload(formData, 'first_products_mockup').then(response => {
                this.specificColor ? this.setProjectConfig(response.data[0], this.specificColor) : this.setProjectConfig(response.data[0]);
                this.specificColor = null;
            })
        },
        setProjectConfig(urlToFetch = null, specificColor = null, showLayer = false){
            this.changedDesign = true;
            var max_width = this.configKonva.width / 2;
            this.fetching_file = true;
            let url = urlToFetch ? this.getStorSrc(urlToFetch) : this.production_full_path_url.includes('storage') ? this.getStorSrc(this.production_full_path_url.split('storage')[1]) : this.getStorSrc(this.production_full_path_url.split('stor')[1]);
            imageData(url).then(res => {
                let widthRatio = 1,x,y;

                if(res.width > 300){
                    let widthRatio2 = 300/res.width;
                    res.width=300;
                    res.height=res.height * widthRatio2;
                }

                if(this.clippingConfig){
                    if(res.width>this.clippingConfig.clipWidth*0.9){
                        widthRatio = (this.clippingConfig.clipWidth/res.width)*0.9;
                    }
                    res.width = res.width*widthRatio;
                    res.height = res.height*widthRatio;

                    if(res.height>this.clippingConfig.clipHeight*0.9){
                        widthRatio = (this.clippingConfig.clipHeight/res.height)*0.9;
                        res.width = res.width*widthRatio;
                        res.height = res.height*widthRatio;
                    }
                    this.projectConfig = {...this.projectConfig, ...res, ...{id: 'layer_'+this.makeid(5),type: 'image', side: this.activeSide, expanded: false}};
                    x = (this.clippingConfig.clipX+(this.clippingConfig.clipWidth) / 2) - (res.width)/2;
                    y = (this.clippingConfig.clipY+(this.clippingConfig.clipHeight) / 2) - (res.height)/2;
                    this.originalX = x;
                    this.originalY = y;
                } else {
                    var larger = null;
                    (res.width > res.height)? larger = 'width' : larger = 'height';
                    var ratio = max_width / res[larger];
                    res.width = res.width * ratio;
                    res.height = res.height * ratio;
                    this.projectConfig = {...this.projectConfig, ...res, ...{id: 'layer_'+this.makeid(5), type: 'image', side: this.activeSide, expanded: false}};
                    x = (this.configKonva.width - this.projectConfig.width) / 2;
                    y = (this.configKonva.height - this.projectConfig.height) / 2;
                    this.$set(this.projectConfig, 'x', x);
                    this.$set(this.projectConfig, 'y', y);
                    this.originalX = x;
                    this.originalY = y;
                }


                let originalSize = {
                    width: this.projectConfig.width,
                    height: this.projectConfig.height
                }

                this.$set(this.projectConfig, 'x', x);
                this.$set(this.projectConfig, 'y', y);
                this.$set(this.projectConfig, 'scaleX', 1);
                this.$set(this.projectConfig, 'scaleY', 1);
                this.$set(this.projectConfig, 'rotation', 0);
                this.$set(this.projectConfig, 'originalSize', originalSize);
                this.$set(this.projectConfig, 'draggable', true);
                delete this.projectConfig.specificColor;
                if(specificColor)  this.$set(this.projectConfig, 'specificColor', specificColor);
                this.fetching_file = false;

                this.layers.unshift(this.projectConfig);
                this.selectedShapeName = this.layers[0].id;
                this.layersReverted.push(this.projectConfig);
                setTimeout(() => {
                    this.updateTransformer();
                    if(showLayer){
                        this.type = 'layer';
                        this.layers[0].expanded = true;
                    }
                }, 100);
            })
        },
        updateLayerValue(event, layer, type){
            this.changedDesign=true;
            let x;

            if(layer.type == 'text'){
                const transformerNode = this.transformer.getNode();
                const stage = transformerNode.getStage();
                const stage_elem = stage.findOne('#'+layer.id);
                if(type == 'height'){
                    let height = parseFloat((stage_elem.height()/this.front_print_config.clipWidth)*this.front_print_config.widthInches*layer.scaleX).toFixed(2);
                    let scale = event / height;
                    layer.scaleY *= scale;
                    layer.scaleX *= scale;
                } else if(type == 'width'){
                    let width = parseFloat((stage_elem.width()/this.front_print_config.clipWidth)*this.front_print_config.widthInches*layer.scaleX).toFixed(2);
                    let scale = event / width;
                    layer.scaleY *= scale;
                    layer.scaleX *= scale;
                } else if(type == 'rotation'){
                    layer.rotation = event;
                } else if(type == 'left'){
                    x = this.front_print_config.clipX + ((event) * this.front_print_config.clipWidth)/100;
                    layer.x = x;
                } else if(type == 'top'){
                    x = this.front_print_config.clipY + ((event) * this.front_print_config.clipHeight)/100;
                    layer.y = x;
                }
            } else {
                if(type == 'height'){
                    x = (event*this.front_print_config.clipHeight)/this.front_print_config.heightInches;
                    layer.scaleY = x/layer.height;
                    layer.scaleX = x/layer.height;
                } else if(type == 'width'){
                    x = (event*this.front_print_config.clipWidth)/this.front_print_config.widthInches;
                    layer.scaleX = x/layer.width;
                    layer.scaleY = x/layer.width;
                } else if(type == 'top'){
                    x = this.front_print_config.clipY + ((event) * this.front_print_config.clipHeight)/100;
                    layer.y = x;
                } else if(type == 'left'){
                    x = this.front_print_config.clipX + ((event) * this.front_print_config.clipWidth)/100;
                    layer.x = x;
                } else if(type == 'rotation'){
                    layer.rotation = event;
                }
            }


        },
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }
            return result;
        },
        deleteLayer(id){
            this.changedDesign = true;
            let index = -1;
            this.layers.forEach((layer,ind)=>{
                if(layer.id == id) index = ind;
            })
            if(index>=0) this.layers.splice(index, 1);
            index = -1;
            this.layersReverted.forEach((layer,ind)=>{
                if(layer.id == id) index = ind;
            })
            if(index>=0) this.layersReverted.splice(index,1);

        },
        addTextLayerMethod(specificColor = null, text = null, fontFamily = null, fill = null, showLayer = false){
            let id = this.makeid(5);
            let config = {
                draggable: true,
                x: (this.config.x),
                y: (this.config.y + (this.config.width/2)) - 26,
                text: text ? text : "Your text",
                fontSize: 26,
                fontFamily: fontFamily ? fontFamily : 'Kanit',
                fill: fill ? fill : '#201F1F',
                id: 'layer_'+id,
                scaleX: 1,
                scaleY: 1,
                rotation: 0,
                type: 'text',
                side: this.activeSide,
                expanded: false
            }
            if(specificColor)  this.$set(config, 'specificColor', specificColor);
            this.layers.unshift(config);
            this.selectedShapeName = this.layers[0].id;
            this.layersReverted.push(config);
            setTimeout(()=>{
                const transformerNode = this.transformer.getNode();
                const stage = transformerNode.getStage();
                const stage_elem = stage.findOne('#layer_' + id);
                if(showLayer){
                    this.type = 'layer';
                    this.layers[0].expanded = true;
                }
                // let layer = this.$editCustomization.layers[0];
                // layer.width = stage_elem.width();
                // layer.height = stage_elem.height();
            },100);
        },
        copyLayer(id){
            this.changedDesign = true;
            let index = -1;
            this.layers.forEach((layer,ind)=>{
                if(layer.id == id) index = ind;
            });
            if(index>=0){
                let obj = {
                    ...this.layers[index]
                }
                obj.id = 'layer_'+this.makeid(5);
                this.layers.unshift(obj);
                this.layersReverted.push(obj);
            }
        },
        addTextLayer(){
            this.changedDesign = true;
            this.specificColor ? this.addTextLayerMethod(this.specificColor) : this.addTextLayerMethod();
            this.addLayer = false;
            this.designPanel = 0;
        },
        moveUpGraphic(id){
            this.changedDesign = true;
            let index = -1;
            this.layers.forEach((layer,ind)=>{
                if(layer.id == id) index = ind;
            })

            if(index >= 0){
                let pivot = this.layers[index-1];
                this.layers[index-1] = this.layers[index];
                this.layers[index] = pivot;
                let layers = this.layers;
                this.$set(this,'layers', []);
                this.$set(this,'layers', layers)

                this.$set(this,'layersReverted', []);
                layers.forEach(lay=>this.layersReverted.unshift(lay))

            }
        },
        moveDownGraphic(id){
            this.changedDesign = true;
            let index = -1;
            this.layers.forEach((layer,ind)=>{
                if(layer.id == id) index = ind;
            })
            if(index>=0){
                let pivot = this.layers[index+1];
                this.layers[index+1] = this.layers[index];
                this.layers[index] = pivot;
                let layers = this.layers;

                this.$set(this,'layers', []);
                this.$set(this,'layers', layers);

                this.$set(this,'layersReverted', []);
                layers.forEach(lay=>this.layersReverted.unshift(lay))
            }

        },
        getLayerParams(layer){
            let obj = {
                left: parseFloat(((layer.x - this.front_print_config.clipX)/this.front_print_config.clipWidth)*100).toFixed(2),
                top: parseFloat(((layer.y - this.front_print_config.clipY)/this.front_print_config.clipHeight)*100).toFixed(2),
                rotation: layer.rotation,

            }
            if(layer.width && layer.height){
                obj.width = parseFloat((layer.width/this.front_print_config.clipWidth)*this.front_print_config.widthInches*layer.scaleX).toFixed(2);
                obj.height =parseFloat((layer.height/this.front_print_config.clipHeight)*this.front_print_config.heightInches*layer.scaleY).toFixed(2);
            } else {
                const transformerNode = this.$refs.transformer.getNode();
                const stage = transformerNode.getStage();
                const stage_elem = stage.findOne('#'+layer.id);
                if(stage_elem && stage_elem.width() && stage_elem.height()){
                    obj.width =  parseFloat((stage_elem.width()/this.front_print_config.clipWidth)*this.front_print_config.widthInches*layer.scaleX).toFixed(2);
                    obj.height =  parseFloat((stage_elem.height()/this.front_print_config.clipWidth)*this.front_print_config.widthInches*layer.scaleX).toFixed(2);
                } else {
                    obj.width = 0;
                    obj.height = 0;
                }

            }
            if(layer.fontFamily) {
                obj.fontFamily = layer.fontFamily;
                obj.fill = layer.fill;
            }

            console.log(obj)
            return obj;
        },
        changeColor(color, index){
            this.changedDesign = true;
            if(this.selectedColorsName.indexOf(color)>-1){
                if(this.selectedColorsName.length > 1){
                    index = this.selectedColorsName.indexOf(color);
                    let deletedColor = this.selectedColorsName[index];
                    this.selectedColorsName.splice(index, 1);
                    this.selectedColors.splice(index, 1);
                    if(this.selectedColor == deletedColor) this.selectedColor = this.selectedColorsName[0];
                    this.addVariantColor(color,'remove');}

            } else {
                this.selectedColorsName.push(color);
                this.colorSwatches.forEach(swatch=>{
                    if(swatch.color_name == color) this.selectedColors.push(swatch);
                })
                this.addVariantColor(color,'add');
            }

            let colors = this.colorSwatches;
            this.$set(this,'colorSwatches', []);
            this.$set(this,'colorSwatches', colors);
        },
        addVariantColor(color, type = 'add'){
            if(type == 'add'){
                let found_color = {};
                for (const [key, value] of Object.entries(this.smakeVariants)) {
                    if(key== color){
                        found_color = value;
                    }
                }
                if(found_color.sizes.length > 0){
                    found_color.sizes.forEach(size=>{
                        var finded_2 =  this.product.product.data.variants.find(x => {
                            return x.attributes.find(y => y.name == 'color' && y.value == found_color.color) && x.attributes.find(y => y.name == 'size' && y.value == size);
                        })

                        var sku = found_color.color+'_'+size;
                        let front_print=null,back_print=null,color_swatch=null;
                        if(finded_2.front_print) front_print = finded_2.front_print;
                        if(finded_2.back_print) back_print = finded_2.back_print;
                        if(finded_2.color_swatch) color_swatch = finded_2.color_swatch;
                        var obj = {
                            show:true,
                            smake_id: finded_2.id,
                            sku:sku,
                            id: this.makeid(20),
                            attributes:[],
                            front_print,
                            back_print,
                            color_swatch,
                            price: finded_2.total
                        }
                        obj.attributes.push({
                            custom: false,
                            name: 'Color',
                            type: 'color',
                            value: found_color.color
                        })
                        obj.attributes.push({
                            custom: false,
                            name: 'Size',
                            type: 'text',
                            value: size
                        })
                        if(finded_2.images){
                            obj.photos = finded_2.images.map((item) => {
                                return item.image;
                            })
                        }
                        this.product.variants.push(obj);
                    });
                }

            } else if (type == 'remove'){
                let newVariants = [];

                this.product.variants.forEach(variant => {
                    if(variant.attributes[0].value != color) newVariants.push(variant);
                });
                this.product.variants=newVariants;
            }

        },
        addSpecificDesign(){
            this.specificColor = this.selectedColor;
            this.addLayer = true;
        },
        getProduct(){
            getBread('Product', this.$route.params.id, {relations: ['variants.attributes', 'categories','layers', 'product_integrations']}).then(response => {
                this.product = response;
                this.product.variants.forEach(variant=>{
                    if(this.selectedColorsName.indexOf(variant.attributes[0].value) < 0) this.selectedColorsName.push(variant.attributes[0].value);
                })

                this.printImages = response.product.data.variants[0].images;
                this.setColorSwatches();
                this.setSides();

                setTimeout(()=>{
                    this.getBackgroundImage();
                },200)

                setTimeout(()=>{
                    this.changedDesign = false;
                },2000)
            })
        },
        getStorSrc(src){
            return config.stor+''+src;
        },
        getBackgroundImage(colorCreation = null, urlFromSide = null){
            return new Promise((resolve)=>{
                let color = colorCreation ? colorCreation : this.color;
                let inter = setInterval(()=>{
                    if(this.product && this.product.product.data) {
                        let url, mockup, found = false;
                        let productData = this.product.product.data;
                        if(!urlFromSide){
                            for(let i=0; i<productData.variants.length; i++){
                                if(!found){
                                    for(let j=0;j<productData.variants[i].images.length;j++){
                                        if(color){
                                            if(color == productData.variants[i].attributes[0].value && productData.variants[i].images[j].place == this.activeSide){
                                                url = this.getStorSrc(productData.variants[i].images[j].image);
                                                mockup = productData.variants[i].images[j].image;
                                                j = productData.variants[i].images.length;
                                                found = true;
                                            }
                                        } else {
                                            if(productData.variants[i].images[j].place == this.activeSide){
                                                url = this.getStorSrc(productData.variants[i].images[j].image);
                                                mockup = productData.variants[i].images[j].image;
                                                j = productData.variants[i].images.length;
                                                found = true;
                                            }
                                        }
                                    }
                                } else {
                                    i = productData.variants.length;
                                }
                            }
                        } else {
                            url = this.getStorSrc(urlFromSide);
                        }
                        clearInterval(inter);
                        imageData(url).then(res => {
                            this.selectedVariantImage = mockup;
                            this.background = res;
                            this.refresh();
                            resolve();
                        })

                    }
                },100);
            })

        },
        refresh(){
            let size = document.getElementById('konva-wrapper').offsetWidth;
            if(size > 650) size = 650;
            this.configKonva = {
                width: size,
                height: size,
            }

            if(this.initTransformerImages){
                this.initTransformerImages = false;
                this.styleTransformer();
            }

            if(this.createLayer){
                this.createLayer = false;
                let inter = setInterval(()=>{
                    if(this.product && this.product.product){
                        if(this.firstLaunch) {
                            this.$set(this,'layers',[]);
                            this.setProjectConfig();
                            this.firstLaunch = false;
                        } else {
                            this.$set(this,'layers',[]);
                            this.product.layers.forEach(layer=>{
                                let ley = layer.data;
                                if(ley.type == 'image'){
                                    this.setLayerConfig(ley);
                                } else {
                                    this.wait = false;
                                    this.layers.push(ley);
                                    this.layersReverted.unshift(ley);
                                }
                            });

                            if(!this.wait){
                                this.selectedShapeName = this.layers[0].id;
                                setTimeout(() => {
                                    this.updateTransformer();
                                }, 100)
                            }
                        }
                        clearInterval(inter);
                    }
                },200)
            }
        },
        setLayerConfig(layer){
            this.fetching_file = true;
            let url =  layer.src.includes('storage') ? this.getStorSrc(layer.src.split('storage')[1]) : this.getStorSrc(layer.src.split('stor')[1]);
            imageData(url).then(res => {
                this.projectConfig = {...layer};
                this.projectConfig.image = res.image;
                this.layers.push(this.projectConfig);
                this.layersReverted.unshift(this.projectConfig);
                this.fetching_file = false;

                this.selectedShapeName = this.layers[0].id;
                setTimeout(() => {
                    this.updateTransformer();
                }, 100)

            })
        },
        updateTransformer() {
            this.changedDesign = true;
            const transformerNode = this.$refs.transformer.getNode();
            this.transformer = this.$refs.transformer;
            const stage = transformerNode.getStage();
            const { selectedShapeName } = this;
            const selectedNode = stage.findOne('#' + selectedShapeName);
            if (selectedNode === transformerNode.node()) {
                transformerNode.detach();
            }
            if (selectedNode) {
                transformerNode.attachTo(selectedNode);
            } else {
                transformerNode.detach();
            }
            transformerNode.getLayer().batchDraw();
        },
        handleStageMouseDown(e) {
            // clicked on stage - clear selection
            if (e.target === e.target.getStage()) {
                this.selectedShapeName = null;
                this.updateTransformer();
                return;
            }

            // clicked on transformer - do nothing
            const clickedOnTransformer =
                e.target.getParent().className === 'Transformer';
            if (clickedOnTransformer) {
                return;
            }

            // find clicked rect by its name
            const name = e.target.attrs.id;
            if(typeof name == 'undefined'){
                this.selectedShapeName = null;
                this.updateTransformer();
                return null;
            }

            if(e.target.attrs.id){
                this.selectedShapeName = e.target.attrs.id;
            }else{
                this.selectedShapeName = null;
            }
            this.updateTransformer();
            /*const rect = this.$creator.layers.find(r => r.id=== name);*/
            /*this.updateTransformer();*/
        },
        handleTransformEnd(e) {
            const transformerNode = this.$refs.transformer.getNode();
            const stage = transformerNode.getStage();
            const stage_elem = stage.findOne('#' + this.selectedShapeName);
            if (stage_elem && this.layers) {
                let found = false;

                this.layers.forEach(layer => {
                    if (layer.id == stage_elem.name()) {
                        this.$set(layer, 'x', stage_elem.x());
                        this.$set(layer, 'y', stage_elem.y());
                        this.$set(layer, 'rotation', stage_elem.rotation());
                        this.$set(layer, 'scaleX', stage_elem.scaleX());
                        this.$set(layer, 'scaleY', stage_elem.scaleY());
                        found = true;
                    }
                })
            }
        },
        setSides(){
            if(this.product && this.product.product){
                this.product.product.data.variants.forEach(variant=>{
                    variant.images.forEach(image=>{
                        if(this.sides.indexOf(image.place)<0){
                            this.sides.push(image.place);
                        }
                    })
                    this.activeSide = this.sides[0];
                })
            }
        },
        setColorSwatches(){
            this.product.product.data.variants.forEach(variant=>{
                if(this.colors.indexOf(variant.color_swatch) < 0) {
                    this.colors.push(variant.color_swatch)
                    let obj = {
                        color_name: variant.attributes[0].value,
                        color_swatch: variant.color_swatch
                    }
                    this.colorSwatches.push(obj);
                }
            });

            let selectedColors = [];
            this.colorSwatches.forEach(swatch=>{
                if(this.product.variants.length > 0 ){
                    this.product.variants.forEach(variant=>{
                        if(selectedColors.indexOf(variant.attributes[0].value) < 0 && variant.attributes[0].value == swatch.color_name){
                            this.selectedColors.push(swatch);
                            selectedColors.push(variant.attributes[0].value)
                        }
                    })
                } else {
                    this.product.product.data.variants.forEach(variant=>{
                        if(selectedColors.indexOf(variant.attributes[0].value) < 0 && variant.attributes[0].value == swatch.color_name){
                            this.selectedColors.push(swatch);
                            selectedColors.push(variant.attributes[0].value)
                        }
                    })
                }

            })
            if(this.selectedColorsName.length == 0) {
                this.selectedColors.forEach(color=>{
                    this.selectedColorsName.push(color.color_name);
                    this.addVariantColor(color.color_name, 'add');
                })
            }
            this.selectedColor = this.selectedColorsName.length > 0 ? this.selectedColorsName[0] : null;

        },
    },
    watch:{
        color(newVal, oldVal){
            if(oldVal){
                this.getBackgroundImage();
            }
        },
        changedSide: function(){
            if(this.changedSide) {
                this.changedSide = false;
                this.getBackgroundImage();
            }
        }
    },
}
</script>
